'use client';

import { Search, Scan, Plus, Filter } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface HeaderProps {
  title: string;
  subtitle?: string;
  showSearch?: boolean;
  showActions?: boolean;
  onSearch?: (query: string) => void;
  onAdd?: () => void;
  onScan?: () => void;
}

export function Header({ 
  title, 
  subtitle, 
  showSearch = true, 
  showActions = true,
  onSearch,
  onAdd,
  onScan 
}: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 h-16 bg-[#0A192F]/95 backdrop-blur-sm border-b border-[#1d3557] px-8 flex items-center justify-between">
      <div>
        <h1 className="text-xl font-bold text-[#E6F1FF]">{title}</h1>
        {subtitle && <p className="text-sm text-[#8892B0]">{subtitle}</p>}
      </div>

      <div className="flex items-center gap-4">
        {showSearch && (
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#8892B0]" />
            <Input
              placeholder="搜索..."
              className="w-80 pl-10 bg-[#112240] border-[#1d3557] text-[#E6F1FF] placeholder:text-[#8892B0] focus:border-[#64FFDA] focus:ring-[#64FFDA]/20"
              onChange={(e) => onSearch?.(e.target.value)}
            />
          </div>
        )}

        {showActions && (
          <>
            <Button
              variant="outline"
              size="icon"
              className="border-[#1d3557] text-[#8892B0] hover:text-[#E6F1FF] hover:bg-[#112240]"
            >
              <Filter className="w-4 h-4" />
            </Button>
            <Button
              variant="outline"
              size="icon"
              className="border-[#1d3557] text-[#8892B0] hover:text-[#64FFDA] hover:border-[#64FFDA]"
              onClick={onScan}
            >
              <Scan className="w-4 h-4" />
            </Button>
            <Button
              className="bg-[#64FFDA] text-[#0A192F] hover:bg-[#64FFDA]/90 font-medium"
              onClick={onAdd}
            >
              <Plus className="w-4 h-4 mr-2" />
              新增
            </Button>
          </>
        )}
      </div>
    </header>
  );
}
